module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DB79_1SB_GLU.5e723dc1.png";